import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import TranslationRow from './TranslationRow'

const styles = theme => ({
  spacer: {
    padding: '.5em 0'
  }
})

const TranslationSection =({ title, original, translation, originalHeader, otherHeader, classes, ...rest }) => {
  const renderMultiRows = () => original.reduce((acc, ele, i) => {
    if (ele.length) {
      acc.push(
        <TranslationRow
          key={i}
          original={ele}
          translation={translation[i]}
          index={i}
          {...rest}
        />
      )
    }
    return acc
  }, [])

  const renderSingleRow = () => original.length ? (
    <TranslationRow
      original={original}
      translation={translation}
      {...rest}
    />
  ) : null

  return (
    <Fragment>
      <Grid
        container
        direction="row"
        justify="flex-start"
        className={originalHeader ? classes.spacer : ''}
      >
        <Grid item xs={12} sm={6}>
          <Typography variant="subheading" color="textSecondary">{originalHeader}</Typography>
        </Grid>
        <Hidden only="xs">
          <Grid item sm={6}>
            <Typography variant="subheading" color="textSecondary">{otherHeader}</Typography>
          </Grid>
        </Hidden>
      </Grid>
      <div>
        {Array.isArray(original) ? renderMultiRows() : renderSingleRow()}
      </div>
    </Fragment>
  )
}

TranslationSection.propTypes = {
  title: PropTypes.string,
  original: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  other: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  onChange: PropTypes.func.isRequired,
  sectionKey: PropTypes.string.isRequired
}

export default withStyles(styles)(TranslationSection)


// WEBPACK FOOTER //
// ./src/components/counseling-session/translation/section/TranslationSection.js